// src/components/MobileFooter.js
import React from 'react';

const MobileFooter = () => {
  return (
    <footer className="mobile-footer" role="contentinfo" aria-label="Site footer">
      <div className="mobile-footer-line" />
      <p>© 2025 rankr. All Rights Reserved.</p>
    </footer>
  );
};

export default MobileFooter;
